var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10H1C0.734784 10 0.48043 10.1054 0.292893 10.2929C0.105357 10.4804 0 10.7348 0 11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11C12 10.7348 11.8946 10.4804 11.7071 10.2929C11.5196 10.1054 11.2652 10 11 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49949 0H5.49949C5.36688 0 5.23971 0.0526784 5.14594 0.146447C5.05217 0.240215 4.99949 0.367392 4.99949 0.5V3H2.49949C2.40351 3.0001 2.30958 3.02782 2.22892 3.07986C2.14827 3.1319 2.0843 3.20606 2.04465 3.29347C2.005 3.38089 1.99135 3.47787 2.00533 3.57283C2.01931 3.66779 2.06033 3.75672 2.12349 3.829L5.62349 7.829C5.67042 7.88254 5.72824 7.92544 5.79308 7.95483C5.85793 7.98422 5.9283 7.99942 5.99949 7.99942C6.07068 7.99942 6.14106 7.98422 6.2059 7.95483C6.27074 7.92544 6.32856 7.88254 6.37549 7.829L9.87549 3.829C9.93865 3.75672 9.97967 3.66779 9.99365 3.57283C10.0076 3.47787 9.99398 3.38089 9.95434 3.29347C9.91469 3.20606 9.85072 3.1319 9.77006 3.07986C9.68941 3.02782 9.59548 3.0001 9.49949 3H6.99949V0.5C6.99949 0.367392 6.94681 0.240215 6.85304 0.146447C6.75928 0.0526784 6.6321 0 6.49949 0V0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.07e3cde8aabffac5515cb2c89df605af.svg";
export { ForwardRef as ReactComponent };